import type { FC } from 'react'

import escapeRegExp from 'lodash/escapeRegExp'
import { twMerge } from 'tailwind-merge'

export const Highlight: FC<{ text: string | undefined; pattern?: string; className?: string }> = ({
  text = '',
  pattern = '',
  className,
}) => {
  if (!text) return null

  if (!pattern.trim()) {
    return <span>{text}</span>
  }

  const regex = new RegExp(`(${escapeRegExp(trimQuotationMarks(pattern))})`, 'gi')
  const parts = text.split(regex)

  return (
    <span>
      {parts.filter(Boolean).map((part, i) =>
        regex.test(part) ? (
          <span className={twMerge('bg-yellow-200', className)} key={i}>
            {part}
          </span>
        ) : (
          <span key={i} className={className}>
            {part}
          </span>
        )
      )}
    </span>
  )
}

function trimQuotationMarks(input: string): string {
  return input.replace(/^"|"$/g, '')
}
